import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  // 타임아웃을 60초로 넉넉하게 설정 (파일 업로드 시간 고려)
  timeout: 60000, 
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json'
  }
})

// 에러 인터셉터를 추가해서 서버가 주는 진짜 메시지를 콘솔에 찍어봅시다.
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error Details:', error.response); // 여기서 상세 에러 확인 가능
    return Promise.reject(error);
  }
);

console.log('API Base URL:', process.env.VUE_APP_API_URL)
export default api